module.exports = __webpack_public_path__ + "img/chrome5.d1f38f4e.png";